import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-alert-large',
  templateUrl: './alert-large.component.html',
  styleUrls: ['./alert-large.component.scss']
})
export class AlertLargeComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @Input('text') text = "";
}
